import * as React from 'react';
import styled from 'styled-components';

import T from 'aegisv2/Text';

// Dummy comment to deploy vercel

import { date, getQueryParam, getImgxUrl } from '@crehana/utils';
import { Play4, ArrowBottom } from '@crehana/icons';
import { PrimaryButton, colors } from '@crehana/ui';
import { useCollapse } from '@crehana/react-hooks';
import { useTranslation } from '@crehana/i18n';
import { useMe } from '@crehana/web/dist/ReactContexts/AuthContext';
import { ContactSourceEnum } from '@crehana/web/dist/__generated__/graphql-schema';

import HTMLFromEditors from 'Jsx/Shared/ui/HTMLFromEditors';
import LazyImageV2 from 'Jsx/Shared/LazyImageV2';
import SliderHeaderV3 from 'Jsx/Shared/SliderHeader/V3';
import { useAmplitude, getSourceEventParams } from 'Jsx/Analytics/Amplitude';
import {
  trackUserActivity,
  UserActivityEvent,
} from 'Jsx/Analytics/UserActivity';

import GetPhoneSimpleDialog from 'Jsx/Shared/GetPhoneSimpleDialog';

import { ResourceProps } from '../types';
import localesEs from '../i18n/localeEs';

import { redirectWithQueryParams } from '../helpers';

import { RESOURCE_DETAIL_AMPLITUDE_PAGE_NAME } from '../constants';

import StickyButtomDownload from './StickyButtomDownload';

import { VideoSection, Like, Share } from './index';

const ResourceWrapper = styled.div`
  margin-top: 10px;
  position: relative;
  .title {
    font-family: Poppins, Arial, sans-serif;
    font-size: 28px;
    line-height: 36px;
    @media (min-width: 768px) {
      font-size: 36px;
      line-height: 48px;
    }
  }
  .category {
    margin: 10px 0 20px;
    @media (min-width: 768px) {
      margin: 12px 0 30px;
    }
  }
  .mobileWrapper {
    width: 90%;
    margin: 0 auto;
    .mobileFlex {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
    }
    @media (min-width: 768px) {
      width: 100%;
      margin: 0;
      .mobileFlex {
        display: flex;
        flex-direction: row;
        margin-right: 0;
      }
    }
  }
  @media (min-width: 768px) {
    margin-top: 25px;
  }
  .showMobile {
    display: flex;
    @media (min-width: 1024px) {
      display: none;
    }
  }
`;

const InformationWrapper = styled.div`
  display: flex;
  margin-bottom: 40px;
  @media (min-width: 768px) {
    align-items: center;
  }
  .downloads {
    margin: 10px 0 0 0;
    @media (min-width: 768px) {
      margin: 0 40px 0 15px;
    }
  }
  .views {
    display: flex;
    align-items: center;
    margin-right: 40px;
    span {
      margin-left: 10px;
    }
  }
`;

const Descriptionwrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  .descriptionTitle {
    font-family: Poppins, Arial, sans-serif;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 10px;
    @media (min-width: 768px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  .description {
    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 28px;
    }
  }
`;

const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  .authorTitle {
    font-family: Poppins, Arial, sans-serif;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 10px;
    @media (min-width: 768px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  .authorInfo {
    display: flex;
    .authorAvatar {
      width: 48px !important;
      height: 48px !important;
      margin-right: 10px;
      img {
        border-radius: 50%;
      }
    }
    .authorText {
      display: flex;
      flex-direction: column;
    }
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 200px !important;
  @media (min-width: 768px) {
    height: 404px !important;
    border-radius: 5px !important;
  }
`;

const ShareWrapper = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: block;
    position: relative;
    width: 90%;
    margin: 0 auto;
    max-width: 718px;
    left: -150px;
    .fixedWrapper {
      position: fixed;
      width: 50px;
      top: 280px;
      height: 220px;
    }
  }
`;

interface ResourceType {
  itemType?: 'tool' | 'ebook' | 'tutorial';
  resource: ResourceProps;
}

const Resource: React.FC<ResourceType> = ({
  itemType,
  resource: {
    attachment,
    category,
    downloads,
    resourceCategory,
    title,
    publicationDate,
    videoUrl,
    coverImages,
    originalId,
    downloadUrl,
    likes,
    isLiked,
    views,
    description,
    user: userAuthor,
    richContent,
  },
}) => {
  const { me, loading: loadingMe } = useMe();
  const { logEvent } = useAmplitude();
  const { t } = useTranslation();
  const { getCollapseProps, getToggleProps, isOpen } = useCollapse({
    collapsedHeight: 160,
  });
  const sendTagForTools = category === 'herramientas';
  const [openPhoneDialog, setOpenPhoneDialog] = React.useState(false);

  const handlePhoneDialogSuccess = () => {
    setOpenPhoneDialog(false);
    window.location.href = `${downloadUrl}?platform=direct`;
  };

  const downloadResource = () => {
    if (me) {
      if (itemType === 'ebook' || itemType === 'tool') {
        trackUserActivity({
          event: UserActivityEvent.DOWNLOAD_RESOURCE,
          user: {
            segment: me.segmentationKey!,
            username: me.username!,
          },
          data: {
            product_id: originalId,
            product_name: title,
            item_type: itemType,
          },
        });
      }

      if (window.gtag && sendTagForTools) {
        window.gtag('event', 'Descarga de Herramienta - Logueado', {
          send_to: 'UA-60829200-1',
          event_category: 'Recursos’',
        });
      }

      if (!me.phoneNumber || !me.phoneCode) {
        logEvent({
          // @ts-expect-error
          event: 'Download Resource Without Phone',
          data: {
            ...getSourceEventParams(),
            'Resource name': title,
            source: 'Resource Detail Page',
          },
        });
        setOpenPhoneDialog(true);
      } else {
        logEvent({
          // @ts-ignore
          event: 'Download Resource',
          data: {
            ...getSourceEventParams(),
            'Resource name': title,
            source: 'Resource Detail Page',
          },
          callback: () => {
            window.location.href = `${downloadUrl}?platform=direct`;
          },
        });
      }
    } else {
      if (window.gtag && sendTagForTools) {
        window.gtag('event', 'Descarga de Herramienta - No logueado', {
          send_to: 'UA-60829200-1',
          event_category: 'Recursos',
        });
      }

      if (category !== 'tutoriales') {
        const queryParams = `?next=${window.location.pathname}&source_page=${RESOURCE_DETAIL_AMPLITUDE_PAGE_NAME}&contact_source_enum=${ContactSourceEnum.SOURCE_DOWNLOAD_FREE_RESOURCE}&download=true`;

        redirectWithQueryParams(`/registro/${queryParams}`);
      }
    }
  };

  React.useEffect(() => {
    // Validar telfono tambien, si no tiene telefono mostrar popup de telefono.
    if (!loadingMe && category !== 'tutoriales' && getQueryParam('download')) {
      if (window.gtag && sendTagForTools) {
        window.gtag('event', 'Descarga de Herramienta - Logueado', {
          send_to: 'UA-60829200-1',
          event_category: 'Recursos’',
        });
      }
      downloadResource();
    }
  }, [loadingMe]);

  React.useLayoutEffect(() => {
    const customButtonElements = document.querySelectorAll('#download-button');

    if (customButtonElements?.forEach && customButtonElements?.length > 0) {
      customButtonElements.forEach(node => {
        node.addEventListener('click', downloadResource);
      });
    }
  }, [richContent]);

  return (
    <>
      <ResourceWrapper>
        <div className="mobileWrapper">
          <h1 className="tw-font-semibold title" style={{ fontFamily: 'Poppins' }}>
            {title}
          </h1>
          <div className="category">
            {resourceCategory ? <T>{`${resourceCategory.name},`}</T> : null}
            <T>{`${' '}${date.format(
              publicationDate,
              'DD [de] MMMM [del] YYYY',
            )}`}</T>
          </div>
          <div className="showMobile">
            <Share category={category} />
          </div>
        </div>
        {videoUrl ? (
          <VideoSection videoUrl={videoUrl} category={category} />
        ) : (
          <div style={{ marginBottom: '30px' }}>
            <SliderHeaderV3 showMobile>
              {coverImages.map(c => (
                <StyledImage
                  key={c.imageUrl}
                  src={getImgxUrl(c.imageUrl!, {
                    auto: 'format',
                    w: 718,
                    h: 404,
                    dpr: 2,
                    q: 50,
                  })}
                  alt="recurso"
                  decoding="async"
                />
              ))}
            </SliderHeaderV3>
          </div>
        )}
        <div className="mobileWrapper">
          <InformationWrapper>
            <div className="mobileFlex">
              {category === 'tutoriales' || category === 'lives' ? (
                <div className="views">
                  <Play4 color="#fff" />
                  <T>{`${views}`}</T>
                </div>
              ) : (
                <React.Fragment>
                  <PrimaryButton
                    disabled={loadingMe}
                    onClick={() => downloadResource()}
                    label={t('FREE_DOWNLOAD', {
                      defaultValue:
                        localesEs.es['resource-detail'].FREE_DOWNLOAD,
                    })}
                  />
                  <T className="downloads">{`${downloads} ${t('DOWNLOADS', {
                    defaultValue: localesEs.es['resource-detail'].DOWNLOADS,
                  })}`}</T>
                </React.Fragment>
              )}
            </div>
            <Like
              resourceId={originalId}
              category={category}
              likes={likes}
              isLiked={isLiked}
            />
          </InformationWrapper>
          <Descriptionwrapper
            style={{
              marginBottom: 52,
            }}
          >
            <T bold className="descriptionTitle">
              {category === 'tutoriales'
                ? t('TUTORIALS', {
                    defaultValue: localesEs.es['resource-detail'].TUTORIALS,
                  })
                : t('INFORMATION', {
                    defaultValue: localesEs.es['resource-detail'].INFORMATION,
                  })}
            </T>
            {richContent ? (
              <div
                className="relative"
                css={`
                  &:after {
                    content: '';
                    position: absolute;
                    height: 150px;
                    left: 0;
                    right: 0;
                    bottom: 0px;
                    display: ${isOpen ? 'none' : 'block'};
                    z-index: 1;
                    background: linear-gradient(
                      to top,
                      rgba(255, 255, 255, 1) 0%,
                      rgba(255, 255, 255, 0) 100%
                    );
                  }
                `}
              >
                <div {...getCollapseProps()}>
                  <HTMLFromEditors
                    className="tw-font-pop leading-24 z-3"
                    css={`
                      #download-button {
                        cursor: pointer;
                      }
                    `}
                    dangerouslySetInnerHTML={{
                      __html: richContent,
                    }}
                  />
                </div>
                <button
                  type="button"
                  {...getToggleProps()}
                  className="relative mt-12 z-2"
                >
                  <span className="flex items-center tw-font-semibold font-body3 text-secondary-main">
                    {isOpen ? 'Mostrar menos' : 'Mostrar más'}
                    <span
                      className="flex ml-8"
                      style={isOpen ? { transform: 'rotateZ(180deg)' } : {}}
                    >
                      <ArrowBottom color={colors.secondaryMain} size={14} />
                    </span>
                  </span>
                </button>
              </div>
            ) : (
              <T className="description">{description}</T>
            )}
          </Descriptionwrapper>
          <AuthorWrapper>
            <T bold className="authorTitle">
              {t('POST_BY', {
                defaultValue: localesEs.es['resource-detail'].POST_BY,
              })}
            </T>
            <div className="authorInfo">
              <LazyImageV2
                lazyUrl={userAuthor.profilePictureUrl}
                className="authorAvatar"
              />
              <div className="authorText">
                <T bold>{`${userAuthor.firstName} ${userAuthor.lastName}`}</T>
                {userAuthor.occupation && <T>{`${userAuthor.occupation}`}</T>}
              </div>
            </div>
          </AuthorWrapper>
        </div>
        <ShareWrapper>
          <div className="fixedWrapper">
            <Share category={category} />
          </div>
        </ShareWrapper>
        {attachment && !loadingMe && category !== 'tutoriales' ? (
          <StickyButtomDownload downloadResource={downloadResource} />
        ) : null}
      </ResourceWrapper>
      <GetPhoneSimpleDialog
        title={t('DIALOG_GET_PHONE_TITLE')}
        description={t('DIALOG_GET_PHONE_SUBTITLE')}
        open={openPhoneDialog}
        onSuccess={handlePhoneDialogSuccess}
        hideDialog={() => setOpenPhoneDialog(false)}
        showLegalsCheckbox
        isDark
        sendToCallCenter={{
          enabled: true,
          source: ContactSourceEnum.SOURCE_DOWNLOAD_FREE_RESOURCE,
        }}
      />
    </>
  );
};

export default Resource;
